import React, { createContext, useState, useContext, useCallback } from 'react';

export const MobileTopNavBarContext = createContext();

export const useMobileTopNavBar = () => {
  const context = useContext(MobileTopNavBarContext);
  if (!context) {
    throw new Error('useMobileTopNavBar debe usarse dentro de MobileTopNavBarProvider');
  }
  return context;
};

export const MobileTopNavBarProvider = ({ children }) => {
  const [config, setConfig] = useState({
    hideFilters: false,
    hideBrandSelector: false,
    hideBack: false,
    /** Contenido opcional a la izquierda del icono de filtros (p. ej. Crear campaña en /campaigns) */
    filterAdjacentContent: null,
  });

  const setTopNavBarConfig = useCallback((newConfig) => {
    setConfig(prevConfig => ({
      ...prevConfig,
      ...newConfig,
    }));
  }, []);

  const resetConfig = useCallback(() => {
    setConfig({
      hideFilters: false,
      hideBrandSelector: false,
      hideBack: false,
      filterAdjacentContent: null,
    });
  }, []);

  return (
    <MobileTopNavBarContext.Provider
      value={{
        config,
        setTopNavBarConfig,
        resetConfig,
      }}
    >
      {children}
    </MobileTopNavBarContext.Provider>
  );
};
